var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 4,
    fill: "#FFBEC0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4141 10L14.707 13.293C14.8958 13.4818 15 13.7331 15 14C15 14.2669 14.8958 14.5182 14.707 14.707C14.5182 14.8958 14.2669 15 14 15C13.7331 15 13.4818 14.8958 13.293 14.707L10 11.4141L6.70703 14.707C6.51822 14.8958 6.26693 15 6 15C5.73307 15 5.48178 14.8958 5.29297 14.707C5.10416 14.5182 5 14.2669 5 14C5 13.7331 5.10416 13.4818 5.29297 13.293L8.58594 10L5.29297 6.70703C5.10416 6.51824 5 6.26693 5 6C5 5.73307 5.10416 5.48178 5.29297 5.29297C5.48209 5.10416 5.73307 5 6 5C6.26693 5 6.51791 5.10416 6.70703 5.29297L10 8.58594L13.293 5.29297C13.4821 5.10416 13.7331 5 14 5C14.2669 5 14.5179 5.10416 14.707 5.29297C14.8958 5.48176 15 5.73307 15 6C15 6.26693 14.8958 6.51822 14.707 6.70703L11.4141 10Z",
    fill: "#BB393D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(1 0 0 -1 5 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.4101baac383186f8f043649567e32c4b.svg";
export { ForwardRef as ReactComponent };